import { ActionTypesFactory } from "../../config/helper";

export const Register = ActionTypesFactory("Auth", "Register");
export const NewPassoword = ActionTypesFactory("Auth", "NewPassoword");
export const Sessions = ActionTypesFactory("Auth", "Sessions");
export const ForgotPassoword = ActionTypesFactory("Auth", "ForgotPassoword");
export const ResetPassoword = ActionTypesFactory("Auth", "ResetPassoword");
export const CustomerActivate = ActionTypesFactory("Auth", "CustomerActivate");
export const Logout = ActionTypesFactory("Auth", "Logout");


export const register = (payload) => {
  return {
    type: Register.REQUEST,
    payload,
  };
};

export const customer_activate = (payload) => {
  return {
    type: CustomerActivate.REQUEST,
    payload,
  };
};

export const reset_customer_activate = (payload) => {
  return {
    type: CustomerActivate.RESET,
  };
};

export const reset_register = () => {
  return {
    type: Register.RESET,
  };
};

export const sessions = (payload) => {
  return {
    type: Sessions.REQUEST,
    payload,
  };
};

export const reset_sessions = () => {
  return {
    type: Sessions.RESET,
  };
};

export const new_password = (payload) => {
  return {
    type: NewPassoword.REQUEST,
    payload,
  };
};

export const forgot_password = (payload) => {
  return {
    type: ForgotPassoword.REQUEST,
    payload,
  };
};

export const reset_password = (payload) => {
  return {
    type: ResetPassoword.REQUEST,
    payload,
  };
};

export const logout = (payload) => {
  return {
    type: Logout.REQUEST,
    payload,
  };
};